/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Shop_Channel_MiniappInputs */

const vi_order_shop_channel_miniapp = /** @type {(inputs: Order_Shop_Channel_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo Mini App`)
};

/**

* @param {Order_Shop_Channel_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_shop_channel_miniapp = /** @type {((inputs?: Order_Shop_Channel_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Shop_Channel_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_shop_channel_miniapp(inputs)
});